import { injectable } from 'inversify';
import { observable } from 'mobx';
import { TopicCardModel, TopicModel } from '../../interfaces/models/CardModel';
import { CardStore } from '../CardStore';
import { BaseCardStore } from './BaseCardStore';

@injectable()
export class TopicCardStore extends BaseCardStore<TopicCardModel> {

    @observable stack: TopicModel[] = [];

    constructor(
        protected cardStore: CardStore
    ) {
        super(cardStore);
    }

}
